/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoFormData,
    GeoFormDataFromJSON,
    GeoFormDataFromJSONTyped,
    GeoFormDataToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleListItem
 */
export interface SearchSubRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSubRuleListItem
     */
    state?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SearchSubRuleListItem
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleListItem
     */
    details?: string | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleListItem
     */
    preferredCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleListItem
     */
    prohibitedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof SearchSubRuleListItem
     */
    permittedCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GeoFormData>}
     * @memberof SearchSubRuleListItem
     */
    undesirableConnectionPoints?: Array<GeoFormData> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleListItem
     */
    maxPriceSolutions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSubRuleListItem
     */
    maxPricePoints?: number | null;
    /**
     * 
     * @type {object}
     * @memberof SearchSubRuleListItem
     */
    maxConnectionTime?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    directFlightsOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    excludeDoubleConnections?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    restrictMultiAirportConnections?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    restrictMultiSectorSearch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleListItem
     */
    excludeBaglessFares?: boolean;
}

export function SearchSubRuleListItemFromJSON(json: any): SearchSubRuleListItem {
    return SearchSubRuleListItemFromJSONTyped(json, false);
}

export function SearchSubRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : (json['preferredCarriers'] === null ? null : (json['preferredCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'prohibitedCarriers': !exists(json, 'prohibitedCarriers') ? undefined : (json['prohibitedCarriers'] === null ? null : (json['prohibitedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'permittedCarriers': !exists(json, 'permittedCarriers') ? undefined : (json['permittedCarriers'] === null ? null : (json['permittedCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'undesirableConnectionPoints': !exists(json, 'undesirableConnectionPoints') ? undefined : (json['undesirableConnectionPoints'] === null ? null : (json['undesirableConnectionPoints'] as Array<any>).map(GeoFormDataFromJSON)),
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : json['maxPriceSolutions'],
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : json['maxPricePoints'],
        'maxConnectionTime': !exists(json, 'maxConnectionTime') ? undefined : json['maxConnectionTime'],
        'directFlightsOnly': !exists(json, 'directFlightsOnly') ? undefined : json['directFlightsOnly'],
        'excludeDoubleConnections': !exists(json, 'excludeDoubleConnections') ? undefined : json['excludeDoubleConnections'],
        'restrictMultiAirportConnections': !exists(json, 'restrictMultiAirportConnections') ? undefined : json['restrictMultiAirportConnections'],
        'restrictMultiSectorSearch': !exists(json, 'restrictMultiSectorSearch') ? undefined : json['restrictMultiSectorSearch'],
        'excludeBaglessFares': !exists(json, 'excludeBaglessFares') ? undefined : json['excludeBaglessFares'],
    };
}

export function SearchSubRuleListItemToJSON(value?: SearchSubRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'state': value.state,
        'deleted': value.deleted,
        'allowEdit': value.allowEdit,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'description': value.description,
        'details': value.details,
        'preferredCarriers': value.preferredCarriers === undefined ? undefined : (value.preferredCarriers === null ? null : (value.preferredCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'prohibitedCarriers': value.prohibitedCarriers === undefined ? undefined : (value.prohibitedCarriers === null ? null : (value.prohibitedCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'permittedCarriers': value.permittedCarriers === undefined ? undefined : (value.permittedCarriers === null ? null : (value.permittedCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'undesirableConnectionPoints': value.undesirableConnectionPoints === undefined ? undefined : (value.undesirableConnectionPoints === null ? null : (value.undesirableConnectionPoints as Array<any>).map(GeoFormDataToJSON)),
        'maxPriceSolutions': value.maxPriceSolutions,
        'maxPricePoints': value.maxPricePoints,
        'maxConnectionTime': value.maxConnectionTime,
        'directFlightsOnly': value.directFlightsOnly,
        'excludeDoubleConnections': value.excludeDoubleConnections,
        'restrictMultiAirportConnections': value.restrictMultiAirportConnections,
        'restrictMultiSectorSearch': value.restrictMultiSectorSearch,
        'excludeBaglessFares': value.excludeBaglessFares,
    };
}


